import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@organizacaox/lai-design-system";

export function WhatsAppMicrophoneDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Microfone desconectado</DialogTitle>
          <DialogDescription>
            O microfone desta ligação pelo WhatsApp deixou de estar disponível. O áudio foi pausado,
            mas a ligação continua aberta.
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Reconecte o microfone. O áudio volta quando o navegador recuperar a entrada. Se o aviso
          continuar, encerre a ligação e ligue novamente.
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
